import { render } from "./CaseViewerStats.vue?vue&type=template&id=0117430c&scoped=true"
import script from "./CaseViewerStats.vue?vue&type=script&lang=js"
export * from "./CaseViewerStats.vue?vue&type=script&lang=js"

import "./CaseViewerStats.vue?vue&type=style&index=0&id=0117430c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0117430c"]])

export default __exports__